// extracted by mini-css-extract-plugin
export default {"cardContainer":"style_cardContainer__G-mRl","cardContUp":"style_cardContUp__vPRuu"};